import {
	AncillaryId,
	IAncillary,
} from '../../../../../domain/ancillary/domain/models/IAncillary';
import {
	AncillaryGroupId,
	IAncillaryGroup,
} from '../../../../../domain/ancillary/domain/models/IAncillaryGroup';
import { ICategory, ISubcategory } from '../../category/types';
import { IAncillaryGroupLevel, IAncillaryLevel } from '../../nested-input';

export function adaptAncillaryGroupToCategory(
	{ id, name, headline, description, features, ancillaries }: IAncillaryGroup,
	nestedInputLevel: IAncillaryGroupLevel,
): ICategory<AncillaryGroupId, AncillaryId> {
	const subcategories = ancillaries.map((ancillary, ancillaryIndex) =>
		adaptAncillaryToSubcategory(ancillary, {
			...nestedInputLevel,
			ancillaryIndex,
		}),
	);

	return {
		id,
		title: name,
		subtitle: headline,
		moreInformation: description,
		features,
		subcategories,
	};
}

function adaptAncillaryToSubcategory(
	{ id, name, price }: IAncillary,
	nestedInputLevel: IAncillaryLevel,
): ISubcategory<AncillaryId> {
	return {
		id,
		name,
		price,
		nestedInputLevel,
	};
}
